// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fhy09_ {
  border-radius: 4px;
  border: 1px solid var(--stroke-neutral-subtle);
  padding: var(--spacing-3);
  flex-grow: 1;
}

.kyl7P3 {
  display: flex;
  gap: 0;
  align-items: stretch;
}

.GHrg0y {
  flex: 1;
  padding-right: var(--spacing-3);
  min-width: 0;
  overflow: hidden;
}

.guDJWR {
  flex-shrink: 0;
  padding-left: var(--spacing-3);
}

.ZjyRcM {
  background-color: var(--stroke-neutral-subtle);
  width: 1px;
  align-self: stretch;
}

.sS7cTb {
  color: var(--text-neutral-dark);
  line-height: var(--line-height-auto);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  margin: 0 0 var(--spacing-2) 0;
}

.SmFLXV {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  margin-bottom: 6px;
}

.H6soqs {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  min-width: 0;
  width: 100%;
}

.uTPd2r {
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: 4px;
  padding: 14px 8px;
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: 20px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}

.hTJFkM {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: center;
  flex-shrink: 0;
}

.lNDbVB {
  width: 16px;
  height: 16px;
}

.y5HPnw {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.g3mlmT {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.auSLC_ {
  margin: 0;
  color: var(--text-neutral-dark);
  line-height: var(--line-height-auto);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.zjZNIj {
  position: relative;
  display: inline-block;
}

.Y57cJU {
  width: 120px;
  height: 120px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.Y57cJU:hover {
  opacity: 0.8;
}

.aYey4r {
  margin-top: var(--spacing-2);
  align-self: center;
}

.RMv32q {
  padding: 0;
}

.oUN3wU {
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: color 0.2s ease;
}

.oUN3wU:hover {
  color: #495057;
}

.pND7fc.kyl7P3 {
  align-items: center;
}

.pND7fc .GHrg0y {
  padding-right: 0;
}

.pND7fc .sS7cTb {
  margin-bottom: 4px;
}

.pND7fc .SmFLXV {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .Fhy09_ {
    padding: 16px;
  }

  .kyl7P3 {
    flex-direction: column;
    gap: 24px;
  }

  .GHrg0y {
    padding-right: 0;
    overflow: visible;
  }

  .guDJWR {
    padding-left: 0;
  }

  .ZjyRcM {
    display: none;
  }

  .H6soqs {
    flex-direction: column;
    align-items: stretch;
  }

  .uTPd2r {
    white-space: normal;
    word-break: break-all;
    text-overflow: clip;
    overflow: visible;
  }

  .sS7cTb {
    font-size: 16px;
  }

  .SmFLXV {
    font-size: 13px;
  }

  .hTJFkM {
    width: 100%;
    min-width: auto;
  }

  .Y57cJU {
    width: 100px;
    height: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/RechargePaymentBolepixPage/components/RechargePaymentBolepixCode/RechargePaymentBolepixCode.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".container {\n  border-radius: 4px;\n  border: 1px solid var(--stroke-neutral-subtle);\n  padding: var(--spacing-3);\n  flex-grow: 1;\n}\n\n.pixSection {\n  display: flex;\n  gap: 0;\n  align-items: stretch;\n}\n\n.leftSection {\n  flex: 1;\n  padding-right: var(--spacing-3);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.rightSection {\n  flex-shrink: 0;\n  padding-left: var(--spacing-3);\n}\n\n.separator {\n  background-color: var(--stroke-neutral-subtle);\n  width: 1px;\n  align-self: stretch;\n}\n\n.title {\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-auto);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  margin: 0 0 var(--spacing-2) 0;\n}\n\n.description {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  margin-bottom: 6px;\n}\n\n.codeContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n  min-width: 0;\n  width: 100%;\n}\n\n.codeText {\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: 4px;\n  padding: 14px 8px;\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: 20px;\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.copyButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 160px;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.copyIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.qrSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.qrTitleContainer {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.qrTitle {\n  margin: 0;\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-auto);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n}\n\n.qrCodeContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.qrCodeImage {\n  width: 120px;\n  height: 120px;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.qrCodeImage:hover {\n  opacity: 0.8;\n}\n\n.generatePixButton {\n  margin-top: var(--spacing-2);\n  align-self: center;\n}\n\n.downloadButton {\n  padding: 0;\n}\n\n.downloadIcon {\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.downloadIcon:hover {\n  color: #495057;\n}\n\n.withoutPaymentCode.pixSection {\n  align-items: center;\n}\n\n.withoutPaymentCode .leftSection {\n  padding-right: 0;\n}\n\n.withoutPaymentCode .title {\n  margin-bottom: 4px;\n}\n\n.withoutPaymentCode .description {\n  margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .pixSection {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  .leftSection {\n    padding-right: 0;\n    overflow: visible;\n  }\n\n  .rightSection {\n    padding-left: 0;\n  }\n\n  .separator {\n    display: none;\n  }\n\n  .codeContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .codeText {\n    white-space: normal;\n    word-break: break-all;\n    text-overflow: clip;\n    overflow: visible;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .description {\n    font-size: 13px;\n  }\n\n  .copyButton {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .qrCodeImage {\n    width: 100px;\n    height: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Fhy09_`,
	"pixSection": `kyl7P3`,
	"leftSection": `GHrg0y`,
	"rightSection": `guDJWR`,
	"separator": `ZjyRcM`,
	"title": `sS7cTb`,
	"description": `SmFLXV`,
	"codeContainer": `H6soqs`,
	"codeText": `uTPd2r`,
	"copyButton": `hTJFkM`,
	"copyIcon": `lNDbVB`,
	"qrSection": `y5HPnw`,
	"qrTitleContainer": `g3mlmT`,
	"qrTitle": `auSLC_`,
	"qrCodeContainer": `zjZNIj`,
	"qrCodeImage": `Y57cJU`,
	"generatePixButton": `aYey4r`,
	"downloadButton": `RMv32q`,
	"downloadIcon": `oUN3wU`,
	"withoutPaymentCode": `pND7fc`
};
module.exports = ___CSS_LOADER_EXPORT___;
